import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    inputs: {
      div: {
        background: 'red',
      },
    },
  };
});

export default useStyles;
